<script setup lang="ts">
/**
 * DefaultLayout — 顶部品牌条 + 主内容插槽 + 底部状态条
 * 1080×1920 竖屏 Kiosk 布局骨架
 *
 * E.3-1：使用 <slot /> 替代内嵌 <RouterView>，由 App.vue 控制路由
 */
defineOptions({ name: 'DefaultLayout' })
</script>

<template>
  <div class="kiosk-fullscreen flex flex-col bg-kiosk-bg">
    <!-- 主内容区（flex-1 撑满剩余高度） -->
    <!-- 各页面自己包含 KioskHeader / KioskFooter，Layout 仅提供容器 -->
    <div class="flex min-h-0 flex-1 flex-col overflow-hidden">
      <slot />
    </div>
  </div>
</template>
